module.exports = __webpack_public_path__ + "static/media/useSelections_off.02caee02.jpg";